import { ReactNode } from 'react';

import { Styles, css } from '@flipster/styled-system/css';

export const MaxWidthLayout = ({ children, css: cssProps }: { children: ReactNode; css?: Styles }) => {
  return (
    <section className={css({ maxW: 'desktopMaxWidth', mx: 'auto', px: 16, boxSizing: 'content-box' }, cssProps)}>
      {children}
    </section>
  );
};
